/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },

        actions: {
            slidesPerView: 1,
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 1000,
            spaceBetween: 16,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
            autoplay: {
                disableOnInteraction: false,
                delay: 3000
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;
                    const takeButton = document.querySelector(".js-take");
                    const totalSlideTemplate = document.querySelector("#actionTotal");
                    const totalSlideContent = totalSlideTemplate && totalSlideTemplate.content;

                    if (takeButton && totalSlideTemplate) {
                        takeButton.addEventListener("click", function (evt) {
                            evt.preventDefault();
                            takeButton.setAttribute("disabled", true);
                            swiperContainer.swiper.removeAllSlides();
                            swiperContainer.swiper.appendSlide(totalSlideTemplate.content.cloneNode(true));
                        });
                    }

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },

        articles: {
            slidesPerView: 1.1792,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 16,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24
                }
            }
        },

        advantages: {
            slidesPerView: 1.1792,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 8,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16
                }
            }
        }
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});